import React, { FC, ReactNode, useEffect } from 'react'
import './ResponseExtendedBuyerLeadsStep.scss'
import { useDispatch, useSelector } from 'react-redux'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { BuyerLeadsValuePropositionIcon } from '../../components/icons/StepIcons/BuyerLeadsValuePropositionIcon'
import { reportTrackingEvent } from '../../tracking/thunks'
import { useReportViewEvent, useResponsive } from '../../hooks'
import { Footer } from '../../components/Footer/Footer'
import { ReduxState } from '../../store/reducers'
import { toCurrency } from '../../utils/currencyFormat'

export const ResponseExtendedBuyerLeadsStep: FC<ReactNode> = () => {
  const dispatch = useDispatch()
  const { isMobile } = useResponsive()
  const {
    lead: { affordability },
  } = useSelector((state: ReduxState) => state)

  useReportViewEvent({
    pageTitle: 'response',
    customDimensions: {
      ga_cd_rle_intent: 'buy_extended',
    },
  })

  useEffect(() => {
    dispatch(
      reportTrackingEvent({
        pageTitle: 'response',
        label: 'request_basic',
        inputValue: 'buy_extended',
        eventName: 'lead_submit',
        customDimensions: {
          ga_cd_rle_intent: 'buy_extended',
        },
      })
    )
  }, [])

  const headline = 'Wir können mit deiner Suche starten'
  ;('\n')

  return (
    <>
      <StepTemplate
        headline={''}
        footer={isMobile && <Footer />}
        displayNext={false}
        hideIconOnMobile={false}
        displayBack={false}
        className='response-buyer-leads-step'
      >
        <BuyerLeadsValuePropositionIcon />
        <div className='sub-icon-content align-center padding-bottom-l'>
          <p className={'font-bold'}>Svenja Gruber</p>
          <p>Deine persönliche Immobilienspezialistin</p>
        </div>
        <div className='align-center' data-testid='response-step-headline'>
          <h3>{headline}</h3>
        </div>

        <div className='affordability-container padding-bottom-m'>
          <div className='indicator indicator--tag' role='presentation' data-testid='affordability'>
            <span>
              Du kannst dir bis zu{' '}
              <span className='pading-left-s highlighter'>{toCurrency(affordability ? affordability : 0)}</span> als
              Gesamtkosten leisten.
            </span>
          </div>
        </div>

        <div
          className='response-buyer-leads-step-sub-headline lap-hide palm-hide'
          data-testid='response-sub-headline-palm'
        >
          Jetzt heißt es: Zurücklehnen und entspannen. Unsere Partner melden sich in Kürze bei <br />
          dir und finden für dich die perfekte Immobilie.
        </div>
        <div className='response-buyer-leads-step-sub-headline desk-hide' data-testid='response-sub-headline-desk'>
          Jetzt heißt es: Zurücklehnen und entspannen. Unsere Partner melden sich in Kürze bei dir und finden für dich
          die perfekte Immobilie.
        </div>
        <div className='grid-item one-whole margin-top-xxl padding-horizontal-l align-center'></div>
      </StepTemplate>
      {!isMobile && <Footer />}
    </>
  )
}

export default ResponseExtendedBuyerLeadsStep
